/**
 * Returns a new Date object with the given date set to midnight (00:00:00).
 * If no date string is provided, the current date is used.
 *
 * @param {string} [dateString] - Optional string representation of the date, in YYYY-MM-DD format.
 * @returns {Date} A new Date object with the given date set to midnight.
 */
export const getMidnightDate = (dateString?: string) => {
  const date = dateString ? new Date(dateString) : new Date();
  date.setHours(0, 0, 0, 0);
  return date;
};
